import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getLabelStatus } from './index'
import { statusResolver } from './../../../main/status';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center'
  },
  content: {
    minWidth: '100%',
    padding: '4px 12px',
    margin: '8px 0',
    borderRadius: 4,
    fontWeight: 600,
    textAlign: 'center',
    color: props => theme.palette.getContrastText(theme.palette.pages[props.statusPage] || '#FFF'),
    backgroundColor: props => theme.palette.pages[props.statusPage] || '#FFF',
  }
}));

export default function Status(props) {
  const { status } = props;
  const statusPage = statusResolver[status] ?? 'pendency';
  const classes = useStyles({ statusPage });

  return (
    <div className={classes.content}>
      <span>{getLabelStatus[statusPage] ?? status}</span>
    </div>
  );
}